<template>
  <ion-page class="before-test">
    <img class="before-test_mask" src="@/assets/teacher_index/version5/test_mask.png" alt="" />
    <ion-header class="ion-no-border">
      <div class="navbar flex-row align-center justify-between">
        <div class="nav-icon"></div>
        <span>训后检测</span>
        <div class="nav-icon"></div>
        <switch-font-size />
        <!--        <img
          class="nav-icon"
          :src="getBrandImageUrl('close_icon.png')"
          alt=""
          @click="onCloseThisPage"
        />-->
      </div>
    </ion-header>
    <div class="word-box">
      <VideoHeight />
      <div id="before-test_outside_id" class="before-test_outside">
        <div class="statistic">{{ dataList.length }}个单词</div>
        <div
          id="test_page_id"
          class="before-test_page"
          :class="{ 'scroll-disabled': !canScroll() }"
          @scroll="ionScroll($event)"
          @wheel="preventScroll"
          @touchmove="preventScroll"
        >
          <div class="word-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="word-list_item flex-row justify-between align-center cursor-pointer"
              :class="{ 'choose-true': item.selected === 2, 'choose-false': item.selected === 1 }"
              @click="onShowParaphrase(index, item, $event)"
            >
              <span class="word-style flex-row align-center" style="width: calc(100% - 20%)">
                <span class="word-style gray-color"
                  ><span class="font-small-size" style="flex-shrink: 0; font-size: 14px"
                    >{{ index + 1 }}.</span
                  >&nbsp;</span
                >
                <span class="weight-600 switch-font-size-video"> {{ item.word }}</span>
                <span v-show="item.showParaphrase == 2" class="cnword word-style gray-color ml-3">{{
                  item.paraphrase
                }}</span>
              </span>
              <div class="choose-icon flex-row align-center">
                <img
                  v-if="item.selected === 0 || item.selected === 2"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 1"
                  class="test-icon"
                  src="@/assets/teacher_index/version5/checked_word_false.svg"
                  alt=""
                  @click.stop="onClickYes(item, $event)"
                />
                <img
                  v-if="item.selected === 0 || item.selected === 1"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/word_ok.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <img
                  v-if="item.selected === 2"
                  class="test-icon ml-3"
                  src="@/assets/teacher_index/version5/checked_word_true.svg"
                  alt=""
                  @click.stop="onClickNot(item, $event)"
                />
                <!--                <img-->
                <!--                    class="test-icon ml-3"-->
                <!--                    :src="getBrandImageUrl('speed/not_play_icon.png')"-->
                <!--                    alt=""-->
                <!--                />-->
                <!--                <img-->
                <!--                    v-if="false"-->
                <!--                    class="test-icon ml-3"-->
                <!--                    :src="getBrandImageUrl('speed/playing_icon.png')"-->
                <!--                    alt=""-->
                <!--                />-->
              </div>
            </div>
            <ion-content>
              <ion-infinite-scroll
                id="infinite-scroll"
                threshold="100px"
                :disabled="isDisabled"
                @ionInfinite="loadData($event)"
              >
                <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="数据加载中...">
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </ion-content>
          </div>
        </div>
      </div>
    </div>
    <div class="before-test_bottom">
      <div class="before-test_bottom-content flex-row justify-between align-center">
        <div>
          <span
            >正确<span class="orange-color">{{ yesNum }}</span></span
          >
          <span
            >错误<span class="common-color">{{ notNum }}</span></span
          >
        </div>
        <div>
          <ion-button v-if="dataList.length" class="submit-button" shape="round" @click="doSubmit"
            >提交
          </ion-button>
          <ion-button
            v-if="closeButtonVisible"
            class="golden_bg"
            shape="round"
            @click="onCloseThisPage"
            >关闭
          </ion-button>
          <!--          <ion-button v-if="userinfo.account=='ztt'" class="green_bg" shape="round" @click="selectAll">全选</ion-button>-->
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
/* eslint-disable */

import {
  actionSheetController,
  alertController,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonLabel,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  modalController,
} from "@ionic/vue"
import mqttServer from "@/js/mqtt"
import { checkmarkCircle, closeCircle, library } from "ionicons/icons"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"
import CutBoxEndModal from "@/views/personal/CutBoxEndModal.vue"
import { getBrandImageUrl } from "@/js/brandImages"
import PageDialog from "@/components/PageDialog.vue"
import pagesQueue from "@/js/pagesQueue"
import { openMsgToast } from "@/js/message"
import VideoHeight from "@/views/liveVideo/components/videoHeight.vue"
import { useStorage } from "@vueuse/core"
import { debounce } from "lodash"
import SwitchFontSize from "@/views/liveVideo/components/switchFontSize.vue"

export default {
  name: "SpeedAfterTest",
  props: ["studentId", "showCloseButton", "notForce", "currentAtmId"],
  components: {
    IonInfiniteScrollContent,
    PageWhiteBackground,
    IonInfiniteScroll,
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonButton,
    IonButtons,
    IonItem,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonFooter,
    IonText,
    IonRefresher,
    IonRefresherContent,
    VideoHeight,
    SwitchFontSize,
  },

  setup() {
    // 获取会话存储中学生和老师单词列表高度
    const studentOffsetHeight = useStorage("studentOffsetHeight", "", sessionStorage)
    const teacherOffsetHeight = useStorage("teacherOffsetHeight", "", sessionStorage)
    // 获取会话存储中学生和老师单词列表宽度
    const studentOffsetWidth = useStorage("studentOffsetWidth", "", sessionStorage)
    const teacherOffsetWidth = useStorage("teacherOffsetWidth", "", sessionStorage)
    return {
      closeCircle,
      checkmarkCircle,
      library,
      studentOffsetHeight,
      teacherOffsetHeight,
      studentOffsetWidth,
      teacherOffsetWidth,
    }
  },

  data() {
    return {
      debounceTimer: null,
      debouncedScrollHandler: null, // 防抖滚动处理函数
      canScrollPermission: true, // 添加响应式的滚动权限状态
      instructData: {
        project: "lxll",
        page: "teachIndex",
        module: "AfterTest",
        pageModle:true,
        userType: 1,
        data: null,
        fn: "",
        param: null,
        timestamp: " ",
      },
      isDisabled: false,
      dataList: [],
      yesNum: 0,
      notNum: 0,
      selectYesIndex: [], // 巡查官使用该数组确保展示同步
      selectNotIndex: [], // 巡查官使用该数组确保展示同步
      courseId: undefined,
      courseName: undefined,
      closeButtonVisible: false, //关闭按钮是否显示
      totalNum: 0,
      timeout: false,
    }
  },

  methods: {
    getBrandImageUrl,

    // 检查当前用户是否有发送权限（即是否有滚动权限）
    canScroll() {
      const appointment = this.store.getAppointment()
      // 如果是巡查官，总是可以滚动,或者不是视频课，也能滚动
      if (this.userinfo.isAdmin || appointment.videoFlag != 1) {
        return true
      }
      // 使用响应式的权限状态
      return this.canScrollPermission
    },

    // 更新滚动权限状态
    updateScrollPermission() {
      this.canScrollPermission = mqttServer.getCanSend()
    },

    // 阻止滚动事件
    preventScroll(e) {
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    // 滚动事件监听
    ionScroll(e) {
      // 检查是否有滚动权限
      if (!this.canScroll()) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
      // 使用 lodash debounce 替代 setTimeout
      this.debouncedScrollHandler(e)
    },

    //处理滚动事件
    handleScroll(e) {
      let dom = document.getElementById("test_page_id")
      // let domHeight = document.getElementById('scroll-wrap-article').clientHeight
      // let scrollHeight = e * domHeight
      dom.scrollTop = e
    },

    // 处理消息
    async onMessageReceived(msg) {
      // 确保 msg.fn 是 this 上的有效函数
      if (typeof this[msg.fn] !== "function") {
        throw new Error(`Method ${msg.fn} is not a function`)
      }

      try {
        // 根据 params 是否为数组决定如何调用方法
        if (Array.isArray(msg.params)) {
          await this[msg.fn](...msg.params)
        } else {
          await this[msg.fn](msg.params)
        }
        return true
      } catch (error) {
        console.error("Error executing method:", error)
        throw error // 或者根据需要处理错误
      }
    },

    //关闭本页面
    onCloseThisPageSync() {
      pagesQueue.queuePagePop()
      modalController.dismiss()
    },
    //关闭本页面
    onCloseThisPage() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [],
          fn: "onCloseThisPageSync",
          msgType: "function",
        })
        .then(() => {
          this.onCloseThisPageSync()
        })
    },

    async alertModalNoticeSync() {
      actionSheetController.dismiss()
      // return new Promise(async (resolve) => {
      // if (title == undefined) {
      let title = "提示信息"
      // }
      let message = "21天抗遗忘创建成功。"
      const modal = await modalController.create({
        component: PageDialog,
        id: "PageDialog",
        componentProps: { title, message },
        cssClass: "center_modal_controller_class3",
        backdropDismiss: false,
      })

      modal.onDidDismiss().then((res) => {
        this.backTeacherIndex()
        if (method) {
          method()
        }
        // resolve()
      })
      return modal.present()
      // })
    },

    //关闭本页面 异步
    // onCloseThisPageSync() {
    // pagesQueue.queuePagePop()
    // modalController.dismiss()
    // let dom = document.getElementsByClassName(
    //   "modal_controller_classReview"
    // )[0]
    // if (dom) {
    //   setTimeout(() => {
    //     modalController.dismiss()
    //   }, 1000)
    // }
    // },

    doRefresh(refreshAnimationEvent) {
      this.tools.closeRefreshAnimation(refreshAnimationEvent, 2000)
      this.queryMyWords(refreshAnimationEvent)
    },

    //全部选择
    selectAll() {
      this.dataList.forEach((item) => {
        item.selected = 1
      })
    },

    async handleAlert() {
      const alert = await alertController.create({
        header: "提示",
        message: "21天抗遗忘创建成功。",
        backdropDismiss: false,
        buttons: [
          {
            text: this.$t("确定"),
            handler: () => {
              this.$router.replace("/TeacherIndex")
              pagesQueue.queuePageClear()

              // location.replace("/TeacherIndex")
            },
          },
        ],
      })
    },

    requestGenerateForget(params) {
      return new Promise((resolve, reject) => {
        if (!this.timeout) {
          this.timeout = true
          setTimeout(() => {
            this.timeout = false
          }, 500)
          if (params.aptmId == 0) {
            this.endClassSync()
            resolve("")
          } else {
            this.ajax
              .post("/forget/generateForget", params)
              .then(async (res) => {
                if (res.data.success) {
                  this.alertModalNoticeSync("21天抗遗忘创建成功。")
                  resolve("")
                }
              })
              .catch(() => {
                reject("")
              })
          }
        }
      })
    },

    backTeacherIndex() {
      // mqttServer
      //   .pushMsg(this.instructData, {
      //     params: [],
      //     fn: "endClassSync",
      //     msgType: "function",
      //   })
      //   .then(() => {
      //   })
        this.endClassSync()
    },

    //显示选择资料列表
    async showTeacherSelect(aptmId) {
      return new Promise(async (resolve) => {
        let buttons = []
        for (let i = 5; i < 24; i++) {
          let fill = i < 10 ? "0" : ""
          let time1 = fill + i + ":00"
          let time2 = fill + i + ":30"
          let params1 = { aptmId: aptmId, startTime: time1 }
          let params2 = { aptmId: aptmId, startTime: time2 }
          buttons.push({
            text: time1,
            handler: async () => {
              mqttServer
                .pushMsg(this.instructData, {
                  fn: "alertModalNoticeSync",
                  msgType: "function",
                })
                .then(async () => {
                  await this.requestGenerateForget(params1)
                  resolve()
                })
              // await this.requestGenerateForget(params1)
              resolve()
            },
          })

          buttons.push({
            text: time2,
            cssClass: "teacherSelectButtons",
            handler: async () => {
              mqttServer
                .pushMsg(this.instructData, {
                  fn: "alertModalNoticeSync",
                  msgType: "function",
                })
                .then(async () => {
                  await this.requestGenerateForget(params2)
                  resolve()
                })
              // await this.requestGenerateForget(params2)
              resolve()
            },
          })
        }
        const actionSheet = await actionSheetController.create({
          header: "选择抗遗忘时间 ",
          buttons: buttons,
          backdropDismiss: false,
        })
        setTimeout(() => {
          let dom = document.getElementsByClassName("action-sheet-group")[0]
          dom.addEventListener("scroll", this.handleActionScroll)
        }, 1000)
        await actionSheet.present()
      })
    },

    handleCancelAction() {
      // this.setPageAfterTestIsOpen(false)
      // pagesQueue.queuePageClear()
      // location.replace("/TeacherIndex")
    },

    onShowParaphraseSync(index, item) {
      const currentItem = this.dataList[index]

      this.playSoundTemp(currentItem)
      // for (let i = 0; i < this.dataList.length; i++) {
      //   if (index == i) {
      //     if (this.dataList[i].showParaphrase < 2) {
      //       this.dataList[i].showParaphrase++
      //     } else {
      //       this.dataList[i].showParaphrase = 0
      //     }
      //   } else {
      //     this.dataList[i].showParaphrase = 0
      //   }
      // }
    },

    onShowParaphrase(index, item) {
      mqttServer
        .pushMsg(this.instructData, {
          params: [index, item],
          fn: "onShowParaphraseSync",
          msgType: "function",
        })
        .then(() => {
          this.onShowParaphraseSync(index, item)
        })
      //this.playSound(item.word);
    },

    //记录打对打错单词个数
    countSelectNum() {
      this.yesNum = 0
      this.notNum = 0
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 1) {
          this.yesNum++
        } else if (this.dataList[i].selected == 2) {
          this.notNum++
        }
      }
    },

    //弹出"继续练习"，"结束资料"对话框
    async myAlert1(message) {
      return new Promise(async (resolve) => {
        const modal = await modalController.create({
          id: "CutBoxEndModal",
          component: CutBoxEndModal,
          componentProps: { yesNum: this.yesNum, notNum: this.notNum, selectYesIndex: this.selectYesIndex, selectNotIndex: this.selectNotIndex },
          backdropDismiss: false,
          cssClass: "common_center_70_modal_controller_class",
        })
        await modal.present()

        modal.onDidDismiss().then((res) => {
          resolve(res.data)
        })
      })
    },

    //弹出"结束资料"对话框 强制提交的时候用。
    async myAlert2(message) {
      return new Promise(async (resolve) => {
        const alert = await alertController.create({
          header: "",
          message: message,
          backdropDismiss: false,
          buttons: [
            {
              text: "结束练习，并创建抗遗忘复习",
              handler: () => {
                resolve(true)
              },
            },
          ],
        })
        await alert.present()
      })
    },

    //提交测试结果
    submitTestData(param) {
      return new Promise((resolve) => {
        //如果是陪练自己体验上课流程，则保存体验结束时间
        if (this.userinfo.userType == 2 && this.studentId == this.userinfo.userId) {
          param.trialId = this.store.getTrialId()
          param.list = null
          this.ajax.post("/trial/finishTrialClass", param).then((res) => {
            if (res.data.success) {
              resolve(false) //false为试课
            }
          })
        }

        //正常练习
        else {
          const appointment = this.store.getAppointment()
          param.courseId = appointment.courseId
          this.ajax.post("/vocabulary/updateMastery", param).then((res) => {
            if (res.data.success) {
              resolve(true) //true为正式课
            }
          })
        }
      })
    },

    //响应提交按钮点击事件
    async doSubmit() {
      mqttServer
        .pushMsg(this.instructData, {
          params: [this.selectYesIndex, this.selectNotIndex],
          fn: "doSubmitSync",
          msgType: "function",
        })
        .then(async () => {
          this.doSubmitSync()
        })
    },

    async enClass(param) {
      modalController.dismiss("", "", "CutBoxEndModal")
      await this.showTeacherSelect(param.aptmId)
    },

    endClassSync() {
      this.setPageAfterTestIsOpen(false)
      setTimeout(() => {
        // userType=1 学生回学生首页，否则回陪练首页
        const homePath =
          Number(this.userinfo?.userType) === 1 ? "/StudentIndex" : "/TeacherIndex"
        this.$router.push(homePath)
        pagesQueue.queuePageClear()
      })
    },

    async continueLearningSync(classStatus) {
      this.store.clearAfterTestFlag()
      this.setPageAfterTestIsOpen(false)
      await modalController.dismiss({ status: classStatus })
    },

    async doSubmitSync(selectYesIndex, selectNotIndex) {
      if(this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          this.dataList[selectYesIndex[i]].selected = 1
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          this.dataList[selectNotIndex[i]].selected = 2
        }
      }
      this.countSelectNum()
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected == 0) {
          this.alert("存在未标记单词")
          return
        }
      }

      const message = "正确：" + this.yesNum + ", 错误：" + this.notNum

      let endClass = false
      let classStatus

      //非强制提交
      if (this.notForce) {
        const data = await this.myAlert1(message)
        if (data.hasOwnProperty("status")) {
          endClass = "TO_HOME" === data.status // 是否是常规练习 是 返回true， 否 返回false
          classStatus = data.status
        } else {
          endClass = data
        }
      }
      //强制提交
      else {
        endClass = await this.myAlert2(message)
      }

      const param = {
        studentId: this.studentId,
        list: this.dataList,
        yesNum: this.yesNum,
        notNum: this.notNum,
        wordsNum: this.dataList.length,
        total: this.dataList.length,
      }

      if (this.currentAtmId) {
        param.aptmId = this.currentAtmId
      } else {
        this.appointment = this.store.getAppointment()
        param.aptmId = this.appointment.aptmId
      }

      //提交学后检测结果
      if(this.userinfo.userType == 2) {
        await this.submitTestData(param)
      }

      //如果结束资料，则自动创建21天抗遗忘
      if (endClass) {
        mqttServer
          .pushMsg(this.instructData, {
            params: [param],
            fn: "enClass",
            msgType: "function",
          })
          .then(() => {
            this.enClass(param)
          })
      }

      //继续学习，回到九阶岛
      else {
        // mqttServer
        //   .pushMsg(this.instructData, {
        //     params: [classStatus],
        //     fn: "continueLearningSync",
        //     msgType: "function",
        //   })
        //   .then(() => {
        //   })
          this.continueLearningSync(classStatus)
      }
    },

    onClickYes(item) {
      // 巡查官-找到当前单词在dataList中的索引，并添加到selectYesItems中
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if(yesInd == -1) {
        this.selectYesIndex.push(ind)
        this.selectYesIndex = [...new Set(this.selectYesIndex)]
      } else {
        this.selectYesIndex.splice(yesInd, 1)
      }
      // 巡查官-在selectNotIndex中查找ind，如果存在，则删除
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if (notInd != -1) {
        this.selectNotIndex.splice(notInd, 1)
      }
      
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickYesSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickYesSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectYesIndex的push的ind删除
        this.selectYesIndex.splice(this.selectYesIndex.length - 1, 1)
        // 如果出现错误并且selectNotIndex存在，则把ind重新添加到selectNotIndex中
        if(this.selectNotIndex.length > 0) {
          this.selectNotIndex.push(ind)
          this.selectNotIndex = [...new Set(this.selectNotIndex)]
        }
      }
    },
    //点击异步
    onClickYesSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectYesIndex.length; i++) {
          if(this.dataList[selectYesIndex[i]].selected != 1) {
            this.tools.onClickYes(this.dataList[selectYesIndex[i]])
          }
        }
        for (let i = 0; i < selectNotIndex.length; i++) {
          if(this.dataList[selectNotIndex[i]].selected != 2) {
            this.tools.onClickNot(this.dataList[selectNotIndex[i]])
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把selected设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if(!allIndex.includes(i)) {
            this.dataList[i].selected = 0
          }
        }
        this.countSelectNum()
      } else {
        const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
        this.tools.onClickYes(this.dataList[ind])
        this.countSelectNum()
        this.dataList[ind].showParaphrase = this.dataList[ind].selected === 1 ? 2 : 0
      }
    },

    onClickNot(item) {
      const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
      const notInd = this.selectNotIndex.findIndex((i) => i == ind)
      if(notInd == -1) {
        this.selectNotIndex.push(ind)
        this.selectNotIndex = [...new Set(this.selectNotIndex)]
      } else {
        this.selectNotIndex.splice(notInd, 1)
      }
      // 在selectYesIndex中查找ind，如果存在，则删除
      const yesInd = this.selectYesIndex.findIndex((i) => i == ind)
      if (yesInd != -1) {
        this.selectYesIndex.splice(yesInd, 1)
      }
      try {
        mqttServer
          .pushMsg(this.instructData, {
            params: [item, this.selectYesIndex, this.selectNotIndex],
            fn: "onClickNotSync",
            msgType: "function",
          })
          .then(() => {
            this.onClickNotSync(item)
          })
      } catch (error) {
        // 如果出现错误，则把前面selectNotIndex的push的ind删除
        this.selectNotIndex.splice(this.selectNotIndex.length - 1, 1)
        // 如果出现错误并且yesInd存在，则把ind重新添加到selectYesIndex中
        if(yesInd != -1) {
          this.selectYesIndex.push(ind)
          this.selectYesIndex = [...new Set(this.selectYesIndex)]
        }
      }
    },
    //点击打错异步
    onClickNotSync(item, selectYesIndex, selectNotIndex) {
      if (this.userinfo.isAdmin) {
        for (let i = 0; i < selectNotIndex.length; i++) {
          if(this.dataList[selectNotIndex[i]].selected != 2) {
            this.tools.onClickNot(this.dataList[selectNotIndex[i]])
          }
        }
        for (let i = 0; i < selectYesIndex.length; i++) {
          if(this.dataList[selectYesIndex[i]].selected != 1) {
            this.tools.onClickYes(this.dataList[selectYesIndex[i]])
          }
        }
        // 合并selectYesIndex和selectNotIndex，在dataList中找到索引不等于合并后的索引的单词，把selected设置为0
        const allIndex = [...selectYesIndex, ...selectNotIndex]
        for (let i = 0; i < this.dataList.length; i++) {
          if(!allIndex.includes(i)) {
            this.dataList[i].selected = 0
          }
        }
        this.countSelectNum()
      } else {
        const ind = this.dataList.findIndex((i) => i.vocabularyId == item.vocabularyId)
        this.tools.onClickNot(this.dataList[ind])
        this.countSelectNum()
        this.dataList[ind].showParaphrase = this.dataList[ind].selected === 2 ? 2 : 0
      }
    },

    queryMyWordsSync(res, ev) {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      }, 500)

      if (res.data.success) {
        this.courseName = res.data.courseName
        this.courseId = res.data.courseId
        this.dataList = []
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].selected = 0
          res.data.list[i].showParaphrase = 0
          this.dataList.push(res.data.list[i])
        }

        this.dataList = res.data.list
        if (this.dataList.length == 0) {
          this.closeButtonVisible = true
          if(this.userinfo.isAdmin) {
            openMsgToast("陪练已提交训后检测的单词，请关闭窗口再试！")
          } else {
            this.alert("未查询到用于训后检测的单词！")
          }
        }
        if (ev) {
          ev.target.complete()
        }
      }
    },

    //################################
    // 从服务器读取单词列表
    //################################
    queryMyWords(ev) {
      this.ajax
        .post(
          `/vocabulary/queryAfterTestWords?studentId=${this.studentId}&aptmId=${this.currentAtmId || ""}`
        )
        .then((res) => {
          if (this.$route.path != "/TeacherIndex") {
            this.queryMyWordsSync(res, ev)
            return
          }
          mqttServer
            .pushMsg(this.instructData, {
              params: [res, ev],
              fn: "queryMyWordsSync",
              msgType: "function",
            })
            .then(() => {
              this.queryMyWordsSync(res, ev)
            })
        })
    },
  },

  beforeUnmount() {
    // 清理防抖函数
    if (this.debouncedScrollHandler) {
      this.debouncedScrollHandler.cancel()
    }
    // 移除权限变化监听器
    mqttServer.removePermissionListener(this.updateScrollPermission)
  },

  created() {},

  mounted() {
    // sessionStorage.setItem('pageFlag', 'false')
    mqttServer.onMqttMessage(this.instructData.module, this.onMessageReceived)

    this.userinfo = this.store.getUser()
    this.setPageAfterTestIsOpen(true)

    // 初始化滚动权限状态
    this.updateScrollPermission()
    
    // 添加权限变化监听器
    mqttServer.addPermissionListener(this.updateScrollPermission)

    // 初始化防抖滚动处理函数
    this.debouncedScrollHandler = debounce((e) => {
      
      // 只有有滚动权限的用户才能发送滚动消息
      if (this.canScroll()) {
        mqttServer.pushMsg(this.instructData, {
          params: [JSON.parse(JSON.stringify(e.target.scrollTop))],
          fn: "handleScroll",
          msgType: "function",
          udp: true,
        })
      }
    }, 500)

    if (this.userinfo.userType == "2" || this.$route.path != "/TeacherIndex") {
      this.queryMyWords()
    } else {
      setTimeout(() => {
        sessionStorage.setItem("pageFlag", "true")
      })
    }
    // 巡查官不执行后续代码
    if (this.userinfo.isAdmin) return
    // 等待1秒iframe浏览器渲染完成，设置单词列表高度
    setTimeout(() => {
      let dom = document.getElementById("before-test_outside_id")
      if(this.studentOffsetHeight > this.teacherOffsetHeight) {
        dom.style.height = this.teacherOffsetHeight + "px"
      } else {
        dom.style.height = this.studentOffsetHeight + "px"
      }
      if(this.studentOffsetWidth > this.teacherOffsetWidth) {
        dom.style.width = this.teacherOffsetWidth + "px"
      } else {
        dom.style.width = this.studentOffsetWidth + "px"
      }
    }, 1000)
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.word-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.before-test {
  width: 100%;
  height: 100%;
  position: relative;
  // margin-bottom: 3vh;
  padding: 0 0 20%;
  user-select: none;
  -webkit-user-select: none;
  background: #f2f3f6;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &_mask {
    position: absolute;
    right: 0;
    top: 0;
    width: 12rem;
    z-index: 2;
  }

  &_outside {
    position: relative;
    z-index: 3;
    margin: 0 auto;
    width: 95%;
    height: 80%;
    background: #ffffff;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;

    .statistic {
      color: var(--font-grey-color);
      height: 40px;
      line-height: 40px;
      padding-left: 1rem;
    }
  }

  &_page {
    width: 100%;
    // height: calc(100% - 4rem);
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    &.scroll-disabled {
      overflow: hidden;
      pointer-events: none;
    }

    .word-list {
      &_item {
        padding: 20px;
        border-bottom: 1px solid #eaeaea;

        .word-style {
          display: inline-block;
          font-size: 16px;
          word-break: break-all;
        }

        .choose-icon {
          width: 20%;
          flex-shrink: 0;
        }

        .ml-3 {
          margin-left: 10px;
        }
      }

      .item-checked {
        border: 1px solid var(--theme-color);
      }

      .choose-false {
        background: linear-gradient(0deg, rgba(16, 194, 139, 0.04), rgba(16, 194, 139, 0.04));
      }

      .choose-true {
        background: linear-gradient(0deg, rgba(255, 173, 0, 0.04), rgba(255, 173, 0, 0.04));
      }

      .test-icon {
        width: 24px;
      }
    }

    .statistic {
      color: var(--font-grey-color);
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8%;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 0 var(--font-grey-color);
    z-index: 4;

    &-content {
      height: 60%;
      padding: 3vh 3vw 0;
      color: #9a9b9c;
    }
  }

  .submit-button {
    --background: var(--theme-color);
    --box-shadow: none;
  }
}
</style>
